import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DesignSummaryList from './DesignSummaryList';
import getDesignsSummary from '../actions/getDesignsSummary';
import cartEstimate from '../actions/cartEstimate';
import { getPhoneNumber } from '../utils/index';

const mapDispatchToProps = dispatch => bindActionCreators({
  getDesignsSummary,
  cartEstimate,
}, dispatch);

const mapStateToProps = ({ originReducer, estimateBuilder }) => {
  const { designsSummary } = estimateBuilder;
  const { mode } = originReducer;
  const phoneNumber = getPhoneNumber(mode);

  return {
    designs: designsSummary.designs,
    phoneNumber,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DesignSummaryList);
